<template>
    <div style="width: 100%; height: 100%; margin: 0; padding: 20px; overflow-y: auto; text-align: left; box-sizing: border-box; overflow-x: hidden;">
        <side-menu-header :role="store.state.user.role"></side-menu-header>
        <div class="user__headers">
            Finance
        </div>

        <!-- <div style="position: absolute; top: 18%; width: 18%; height: 3%; text-align: center; text-align: left; padding-top: 0.1%; border: 2px solid #2EA3FF; border-radius: 0.7em;">
        </div> -->

        <div class="finnace__tools finance__list__container">
          <div class="balance-display" style="float: left; border: 1px solid #2EA3FF; border-radius: 5px; padding: 5px 12px; font-size: 24px; line-height: 29px; color: #000000; margin-top: 4px; height: 24px; padding-bottom: 8px;">
            Balance: <b>${{amount}}</b>
          </div>
          <div v-if="store.state.user.stripe != null" class="fund__section">
            <div class="fund__input">
              <span style="position: absolute; left: 11px; top: 12px;">$</span>
              <input id="price-input" type="text" class="input__fund" value="$ 0" v-model="fund">
            </div>
            <div class="fund__button__section" @click='stripeConnectionClick'>
                <form id="payment-form" name="payment-form" :disabled="fund === 0">
                </form>
            </div>
            <!-- <button style="background: rgb(46, 163, 255) none repeat scroll 0% 0%; color: rgb(255, 255, 255); width: 9em; height: 44px; border-radius: 0.6em; border: 1px none rgb(46, 163, 255);">ADD FUNDS</button> -->
          </div>
          <div v-else>
            <div class="stripe__connection">
              <a :href="url" class="stripe-redirect-button" @click="redirect">
                <span>
                  Connect with Stripe
                </span>
              </a>
            </div>
          </div>
        </div>

        <!-- <div class="input-amount" style="float: right; width: 25%;">
        </div> -->

        <div class="finance__list__container">
          <table style="width: 100%;">
            <tr>
              <th class="campaign__header">TRANSACTION</th>
              <th class="advertiser__header">AMOUNT</th>
              <th class="campaignid__header">DATE</th>
              <th class="transaction__status__header">TRANSACTION STATUS</th>
            </tr>
            <tr v-for="transaction in transactions" v-bind:key="transaction.created">
              <td>{{transaction.type}}</td>
              <td>{{transaction.amount}}</td>
              <td>{{dataFormat(transaction.created)}}</td>
              <td>
                <div v-bind:class="[transaction.successful === 'Yes' ? 'approved__status' : 'inactive__status']" style="width: 16px; height: 16px; border-radius: 15px; margin-left: 50%;"></div>
              </td>
            </tr>
          </table>
        </div>
    </div>
</template>

<script>
import SideMenuHeader from './../../components/design/SideMenuHeader.vue'
import store from '@store/index.js'
import { mapGetters } from 'vuex'
import toast from '@utils/toast.js'
export default {
  name: 'Finance',
  data: function () {
    return {
      url: '',
      transactions: [],
      transactionID: 'Transaction ID',
      counter: 0,
      amount: 0,
      accountInfo: null,
      accountLogin: null,
      stripeFormDisplay: false,
      store: store,
      fundInteger: 0,
      fund: 0,
      cssRed: {
        backgroundColor: '#DD4242'
      },
      cssGreen: {
        backgroundColor: '#42DDA1'
      },
      stripeButtonAdder: false
    }
  },
  components: {
    SideMenuHeader
  },
  methods: {
    //requests
    getPayments () {
      var url = '/get/payments'

      this.request(url, 'POST', {}).then((response) => {
          if(response.code === 0){
            this.transactions = response.data
            this.getProfile()
          } else if (response.code === 112){
            this.checkTokenConditions(this.getPayments)
          } else {
            toast.errorMessage(response.message)
          }
      }).catch((error) => {
      })
    },
    getStripeToken (searchFiled) {
      var stripeToken = searchFiled.split('&')[0].split('=')[1]
      const formData = new FormData()
      const json = {
        data: {
          amount: store.getters['getFund'],
          token: stripeToken
        },
        API_KEY: this.store.getters.keys.api_key,
        code: this.token.token,
        user: this.user.user
      }
      formData.append('json', JSON.stringify(json))

      this.request('/make/payment', 'POST', formData).then((response) => {
        if (response.code === 0) {
          // let url = window.location.origin + window.location.pathname
          // window.location.href = url
          if (!this.token.redirect) {
            this.getPayments()
          }
        } else if (response.code === 112) {
          this.checkTokenConditions(this.getStripeToken);
        } else {
            toast.errorMessage(response.message)
            let url = window.location.origin + window.location.pathname
            window.location.href = url
          }
        // window.location.href = 'http://localhost:8080/advertiser/finance'
      }).catch((err) => {

      })
    },
    getProfile () {
      this.request('/get/profile', 'POST', {}).then((response) => {
        if (response.code === 0) {
          store.commit('setUser', response.data[0])
          this.calculateAmount()
          if (response.data[0].stripe) {
            this.initStripeScript()
          }
        } else {
          toast.errorMessage(response.message)
          if (response.code === 112) {
            this.checkTokenConditions(this.getProfile)
          }
        }
      }).catch((error) => {
      })
    },
    checkTokenConditions (callback) {
      try{
        var expiresDate = new Date(this.token.expires)
      } catch (err) {
        this.$router.push('/login')
      }
      var now = new Date()
      if (expiresDate <= now) {
        this.store.commit('setToken', {})
        this.$router.push('/login')
      } else {
        var body = {
          code: '',
          refresh_token: this.token.refresh_token
        }
        this.request('/refresh/token', 'POST', body).then((response) => {
          if (response.code === 0 ) {
            store.commit('setToken', response.data[0])
            store.commit('setDriver', response.data[0].driver)
            callback()
          } else if (response.code === 112) {
            this.store.commit('setToken', {})
            this.$router.push('/login')
          }
        }).catch((error) => {
        })
      }
      var token = this.token
      token.redirect = false
      this.store.commit('setToken', token)
    },

    //setters
    setStripURL () {
      this.url = 'https://connect.stripe.com/express/oauth/authorize?redirect_uri=https://stripe.adwayusa.com/stripe_advertiser_callback.php&client_id=ca_DvruLcfcJ4B2VVGncRn0TWNfPFHvJBs8&state=WEB' + this.token.token + this.user.user
      this.url = this.setExtraParameters(this.url)
    },
    setExtraParameters (url) {
      if (this.user.user !== null || this.user.user !== "") {
        url += '&stripe_user[email]=' + this.user.email
      }

      if (this.user.phone !== null || this.user.phone !== "") {
        url += '&stripe_user[phone_number]=' + this.user.phone
      }

      if (this.user.company !== null || this.user.company !== "") {
        url += '&stripe_user[business_name]=' + this.user.company
      }

      if (this.user.firstname !== null || this.user.firstname !== "") {
        url += '&stripe_user[first_name]=' + this.user.firstname
      }

      if (this.user.surname !== null || this.user.surname !== "") {
        url += '&stripe_user[last_name]=' + this.user.surname
      }

      return url
    },
    redirect () {
      var token = this.token
      token.redirect = true
      this.store.commit('setToken', token)
    },
    addFund () {
      this.stripeFormDisplay = true
      const form = document.getElementById('payment-form')
      form.appendChild(this.stripeScript)
      this.setStripeEventListener()
    },
    setStripeEventListener () {
      setTimeout(() => {
        var self = this
        document.getElementsByClassName('stripe-button-el')[0].addEventListener('click', function () {
          store.commit('setFunds', self.fund)
          document.getElementsByClassName('stripe-button')[0].setAttribute('data-amount', self.fund)
        })
      }, 1000)
    },
    stripeConnectionClick () {
      store.commit('setStripeConnection', true)
    },
    setStripeScript () {
      this.stripeScript = document.createElement('script')
      this.stripeScript.type = 'text/javascript'
      this.stripeScript.src = 'https://checkout.stripe.com/checkout.js'
      this.stripeScript.className = 'stripe-button'
      this.stripeScript.setAttribute('data-key', this.store.getters.keys.stripeKey)
      this.stripeScript.setAttribute('data-amount', 0)
      this.stripeScript.setAttribute('data-email', this.store.state.user.email)
      this.stripeScript.setAttribute('data-label', 'ADD FUNDS')
      this.stripeScript.setAttribute('data-name', 'Adway International Inc.')
      this.stripeScript.setAttribute('data-description', 'Top Up balance')
      this.stripeScript.setAttribute('data-image', 'https://stripe.com/img/documentation/checkout/marketplace.png')
      this.stripeScript.setAttribute('data-currency', 'usd')
      setTimeout(() => {
        this.addFund()
      }, 700)
    },
    initStripeScript () {
      var headerLinks = document.head.childNodes
      var stripIntegrated = false
      headerLinks.forEach(link => {
        if (link.localName === 'script' && link.outerHTML.includes('stripe')) {
          stripIntegrated = true
        }
      })
      if(!stripIntegrated){
        const externalScript = document.createElement('script')
        externalScript.setAttribute('src', 'https://js.stripe.com/v2/')
        document.head.appendChild(externalScript)
      }
      if (!this.stripeButtonAdder){
        this.stripeButtonAdder = true
        this.setStripeScript()
      }
    },

    //calucations
    calculateAmount () {
      this.amount = this.user.balance
    },
    dataFormat (fullName) {
      var dataSplit = fullName.split(' ')
      var date = dataSplit[0]
      var time = dataSplit[1]
      var dateSplit = date.split('-')
      if (!this.isMobile()) {
        var timeSplit = time.split(':')
        return this.makedate(dateSplit) + ' ' + this.makeTime(timeSplit)
      }
      return this.makedate(dateSplit)
    },
    makedate (dateArray) {
      var months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.']
      var string = ''
      string += months[parseInt(dateArray[1]) - 1]
      string += ' ' + dateArray[2] + ', ' + dateArray[0]
      return string
    },
    makeTime (timeArray) {
      var morning = true
      var hours = parseInt(timeArray[0])
      if (hours > 12) {
        morning = false
        hours -= 12
      }
      var string = `${hours > 9 ? '' + hours : '0' + hours}:${timeArray[1]}  ${morning ? 'AM' : 'PM'}`
      return string
    }
  },
  created: function () {
    if (this.token && this.token.redirect) {
      this.checkTokenConditions(this.getPayments)
    } else if (window.location.search.includes('stripeToken')) {
      this.getStripeToken(window.location.search)
    } else {
      this.getPayments()
    }
    this.setStripURL()
  },
  computed: {
    ...mapGetters({
        user: 'getUser',
        token: 'getToken'
    })
  }
}
</script>

<style scoped>

th {
    border-collapse: collapse;
}

th span {
    display: inline-block;
}

th div {
    display: inline-block;
    margin-left: 5px;
    position: relative;
}

tr {
  height: 50px;
}

.table__data {
    height: 50px;
}

table{
    border-collapse: separate;
    border-spacing: 0 8px;
    border-style: hidden;
}

table {
    border-collapse: separate !important;
}

td {
    border: solid 1px transparent;
    background: rgba(235, 234, 244, 0.25);
}

table tr td:first-child {
    border-top-left-radius: 15px;
    border-left-width:15px;
    border-bottom-left-radius: 15px;
}

table tr td:last-child {
    border-top-right-radius: 15px;
    border-right-width:15px;
    border-bottom-right-radius: 15px;
}

.status{
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.stripe-redirect-button{
  display: inline-block;
  margin-bottom: 1px;
  background-image: -webkit-gradient(linear,left top,left bottom,from(#28a0e5),to(#015e94));
  background-image: linear-gradient(#28a0e5,#015e94);
  -webkit-font-smoothing: antialiased;
  border: 0;
  padding: 1px;
  height: 32px;
  text-decoration: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 0 rgba(0,0,0,.2);
  box-shadow: 0 1px 0 rgba(0,0,0,.2);
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: none !important;
}

.stripe-redirect-button span {
  display: block;
  position: relative;
  padding: 0 12px;
      padding-left: 12px;
  height: 30px;
  background: #1275ff;
      background-image: none;
  background-image: -webkit-gradient(linear,left top,left bottom,from(#7dc5ee),color-stop(85%,#008cdd),to(#30a2e4));
  background-image: linear-gradient(#7dc5ee,#008cdd 85%,#30a2e4);
  font-size: 15px;
  line-height: 30px;
  color: #fff;
  font-weight: 700;
  font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
  text-shadow: 0 -1px 0 rgba(0,0,0,.2);
  -webkit-box-shadow: inset 0 1px 0 hsla(0,0%,100%,.25);
  box-shadow: inset 0 1px 0 hsla(0,0%,100%,.25);
  border-radius: 3px;
  padding-left: 44px;
  width: 142px;
}

.stripe-redirect-button span::before {
  background-image: url("./../../assets/stripe_sign.png");
  content: "";
  display: block;
  position: absolute;
  left: 11px;
  top: 50%;
  width: 23px;
  height: 24px;
  margin-top: -12px;
  background-repeat: no-repeat;
  background-size: 23px 24px;
}

#payment-form .stripe-button-el {
  height: 39px !important;
}

#payment-form .stripe-button-el span {
  padding: 4px 12px !important;
  height: 39px !important;
}

@media only screen and (max-width: 792px) {

  .fund__section {
    float: left;
  }
}

</style>
